var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.configurarFacturacion,
              expression: "configurarFacturacion"
            }
          ],
          staticClass: "col-xs-12 col-md-4"
        },
        [
          _c(
            "div",
            { staticClass: "form-field" },
            [
              _c(
                "input-field",
                {
                  attrs: {
                    type: "password",
                    id: "contrasena_firma_electronica",
                    placeholder: "Ingrese la contraseña..."
                  },
                  model: {
                    value: _vm.form.password_firma_digital,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "password_firma_digital", $$v)
                    },
                    expression: "form.password_firma_digital"
                  }
                },
                [
                  _c("span", [_vm._v("Contraseña de firma electrónica")]),
                  _vm._v(" "),
                  _vm.errores.password_firma_digital
                    ? _c(
                        "span",
                        {
                          staticClass: "helper-text text-danger",
                          attrs: { slot: "helper" },
                          slot: "helper"
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.errores.password_firma_digital[0]) +
                              "\n          "
                          )
                        ]
                      )
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.configurarFacturacion,
              expression: "configurarFacturacion"
            }
          ],
          staticClass: "col-xs-12 col-md-4"
        },
        [
          _c(
            "div",
            { staticClass: "form-field" },
            [
              _c(
                "input-field",
                {
                  attrs: {
                    type: "password",
                    id: "contrasena_firma_electronica_confirmation",
                    placeholder: "Confirme la contraseña..."
                  },
                  model: {
                    value: _vm.form.password_firma_digital_confirmation,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.form,
                        "password_firma_digital_confirmation",
                        $$v
                      )
                    },
                    expression: "form.password_firma_digital_confirmation"
                  }
                },
                [
                  _c("span", [
                    _vm._v("Confirme la contraseña de la firma electrónica")
                  ])
                ]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.configurarFacturacion,
              expression: "configurarFacturacion"
            }
          ],
          staticClass: "col-xs-12 col-md-4"
        },
        [
          _c("div", { staticClass: "form-field" }, [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c(
                  "input-field",
                  {
                    attrs: {
                      type: "text",
                      id: "nombre_firma_electronica",
                      placeholder: "Nombre en el archivo de la firma"
                    },
                    model: {
                      value: _vm.form.nombre_firma_electronica,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "nombre_firma_electronica", $$v)
                      },
                      expression: "form.nombre_firma_electronica"
                    }
                  },
                  [
                    _c("span", [
                      _vm._v("Nombre de archivo de firma electrónica")
                    ]),
                    _vm._v(" "),
                    _vm.errores.nombre_firma_electronica
                      ? _c(
                          "span",
                          {
                            staticClass: "helper-text text-danger",
                            attrs: { slot: "helper" },
                            slot: "helper"
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.errores.nombre_firma_electronica[0]
                                ) +
                                "\n            "
                            )
                          ]
                        )
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn-info btn--text",
                    attrs: { type: "button" },
                    on: { click: _vm.descargarFirma }
                  },
                  [_c("i", { staticClass: "fa fa-download" })]
                )
              ],
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.configurarFacturacion,
              expression: "configurarFacturacion"
            }
          ],
          staticClass: "col-xs-12 col-md-4"
        },
        [
          _c("div", { staticClass: "form-field" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("input", {
                attrs: {
                  type: "file",
                  name: "archivo_firma_electronica",
                  id: "archivo_firma_electronica"
                },
                on: { change: _vm.onFileChange }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "archivo_firma_electronica" } }, [
                _vm._v("Archivo de firma electrónica")
              ]),
              _vm._v(" "),
              _c(
                "button",
                { staticClass: "btn-success", on: { click: _vm.subirFirma } },
                [
                  _c("i", { staticClass: "fa fa-upload" }),
                  _c("span", [_vm._v("Subir")])
                ]
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.superadmin === "S",
              expression: "superadmin === 'S'"
            }
          ],
          staticClass: "col-xs-12 col-md-4"
        },
        [
          _c("div", { staticClass: "form-field select2" }, [
            _c(
              "div",
              { staticClass: "select2-field" },
              [
                _c("v-select", {
                  attrs: {
                    label: "descripcion",
                    placeholder: "Seleccione...",
                    id: "tipoAmbiente",
                    options: _vm.tiposAmbiente
                  },
                  model: {
                    value: _vm.selectedTipoAmbiente,
                    callback: function($$v) {
                      _vm.selectedTipoAmbiente = $$v
                    },
                    expression: "selectedTipoAmbiente"
                  }
                }),
                _vm._v(" "),
                _c("label", { attrs: { for: "tipoAmbiente" } }, [
                  _vm._v("Tipo de ambiente")
                ]),
                _vm._v(" "),
                _vm.errores.id_tipo_ambiente
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.errores.id_tipo_ambiente[0]) +
                            "\n          "
                        )
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  type: "text",
                  id: "smtp_user",
                  placeholder: "Usuario SMTP"
                },
                model: {
                  value: _vm.form.smtp_user,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "smtp_user", $$v)
                  },
                  expression: "form.smtp_user"
                }
              },
              [
                _c("span", [_vm._v("Dirección electrónica SMTP (Usuario)")]),
                _vm._v(" "),
                _vm.errores.smtp_user
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.errores.smtp_user[0]) +
                            "\n          "
                        )
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  type: "password",
                  id: "smtp_password",
                  placeholder: "Contraseña SMTP"
                },
                model: {
                  value: _vm.form.smtp_password,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "smtp_password", $$v)
                  },
                  expression: "form.smtp_password"
                }
              },
              [_c("span", [_vm._v("Contraseña SMTP (Usuario)")])]
            ),
            _vm._v(" "),
            _vm.errores.smtp_password
              ? _c(
                  "span",
                  {
                    staticClass: "helper-text text-danger",
                    attrs: { slot: "helper" },
                    slot: "helper"
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.errores.smtp_password[0]) +
                        "\n        "
                    )
                  ]
                )
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  type: "password",
                  id: "smtp_password_confirmation",
                  placeholder: "Confirmación SMTP"
                },
                model: {
                  value: _vm.form.smtp_password_confirmation,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "smtp_password_confirmation", $$v)
                  },
                  expression: "form.smtp_password_confirmation"
                }
              },
              [_c("span", [_vm._v("Confirmar contraseña SMTP (Usuario)")])]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  type: "text",
                  id: "motivo_correo",
                  placeholder: "Escriba el motivo..."
                },
                model: {
                  value: _vm.form.motivo_correo,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "motivo_correo", $$v)
                  },
                  expression: "form.motivo_correo"
                }
              },
              [
                _c("span", [_vm._v("Motivo de correo (Facturación)")]),
                _vm._v(" "),
                _vm.errores.motivo_correo
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.errores.motivo_correo[0]))
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  type: "text",
                  id: "servidor_smtp",
                  placeholder: "Host SMTP"
                },
                model: {
                  value: _vm.form.smtp_host,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "smtp_host", $$v)
                  },
                  expression: "form.smtp_host"
                }
              },
              [
                _c("span", [_vm._v("Servidor SMTP de correos")]),
                _vm._v(" "),
                _vm.errores.smtp_host
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [_c("strong", [_vm._v(_vm._s(_vm.errores.smtp_host[0]))])]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  vMoney: "",
                  format: _vm.int,
                  type: "number",
                  id: "puerto_servidor",
                  placeholder: "Puerto SMTP"
                },
                model: {
                  value: _vm.form.smtp_port,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "smtp_port", $$v)
                  },
                  expression: "form.smtp_port"
                }
              },
              [
                _c("span", [_vm._v("Puerto en el servidor")]),
                _vm._v(" "),
                _vm.errores.smtp_port
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [_c("strong", [_vm._v(_vm._s(_vm.errores.smtp_port[0]))])]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c("div", { staticClass: "form-field" }, [
          _c("label", { attrs: { for: "servidor_smtp_usa_ssl" } }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.smtp_seguridad,
                  expression: "form.smtp_seguridad"
                }
              ],
              attrs: { type: "checkbox", id: "servidor_smtp_usa_ssl" },
              domProps: {
                checked: Array.isArray(_vm.form.smtp_seguridad)
                  ? _vm._i(_vm.form.smtp_seguridad, null) > -1
                  : _vm.form.smtp_seguridad
              },
              on: {
                change: function($event) {
                  var $$a = _vm.form.smtp_seguridad,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 &&
                        _vm.$set(_vm.form, "smtp_seguridad", $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        _vm.$set(
                          _vm.form,
                          "smtp_seguridad",
                          $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                        )
                    }
                  } else {
                    _vm.$set(_vm.form, "smtp_seguridad", $$c)
                  }
                }
              }
            }),
            _vm._v(" "),
            _c("span", [_vm._v("El servidor de correo SMTP usa SSL")])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.superadmin === "S",
              expression: "superadmin === 'S'"
            }
          ],
          staticClass: "col-xs-12 col-md-4"
        },
        [
          _c("div", { staticClass: "form-field" }, [
            _c("label", { attrs: { for: "permitir_facturacion" } }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.permitir_facturacion,
                    expression: "form.permitir_facturacion"
                  }
                ],
                attrs: { type: "checkbox", id: "permitir_facturacion" },
                domProps: {
                  checked: Array.isArray(_vm.form.permitir_facturacion)
                    ? _vm._i(_vm.form.permitir_facturacion, null) > -1
                    : _vm.form.permitir_facturacion
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.form.permitir_facturacion,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(
                            _vm.form,
                            "permitir_facturacion",
                            $$a.concat([$$v])
                          )
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.form,
                            "permitir_facturacion",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.form, "permitir_facturacion", $$c)
                    }
                  }
                }
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Permitir facturación")])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.superadmin === "S",
              expression: "superadmin === 'S'"
            }
          ],
          staticClass: "col-xs-12 col-md-4"
        },
        [
          _c("div", { staticClass: "form-field select" }, [
            _c("div", { staticClass: "select-field" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.tipo_facturacion,
                      expression: "form.tipo_facturacion"
                    }
                  ],
                  attrs: { name: "tipo_facturacion", id: "tipo_facturacion" },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.form,
                        "tipo_facturacion",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                },
                [
                  _c("option", { attrs: { value: "OF" } }, [_vm._v("Offline")]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "ON" } }, [_vm._v("Online")])
                ]
              ),
              _vm._v(" "),
              _c("label", { attrs: { for: "tipo_facturacion" } }, [
                _vm._v("Tipo de facturación")
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.superadmin === "S",
              expression: "superadmin === 'S'"
            }
          ],
          staticClass: "col-xs-12 col-md-4"
        },
        [
          _c("div", { staticClass: "form-field select" }, [
            _c("div", { staticClass: "select-field" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.tipo_consulta_dashboard,
                      expression: "form.tipo_consulta_dashboard"
                    }
                  ],
                  attrs: {
                    name: "tipo_consulta_dashboard",
                    id: "tipo_consulta_dashboard"
                  },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.form,
                        "tipo_consulta_dashboard",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                },
                [
                  _c("option", { attrs: { value: "A" } }, [
                    _vm._v("A la fecha")
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "H" } }, [_vm._v("Hoy")]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "M" } }, [
                    _vm._v("Mes actual")
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "P" } }, [
                    _vm._v("Personalizado")
                  ])
                ]
              ),
              _vm._v(" "),
              _c("label", { attrs: { for: "tipo_consulta_dashboard" } }, [
                _vm._v("Tipo de consulta inicial en dashboard")
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.superadmin === "S",
              expression: "superadmin === 'S'"
            }
          ],
          staticClass: "col-xs-12 col-md-4"
        },
        [
          _c(
            "div",
            { staticClass: "form-field" },
            [
              _c(
                "input-field",
                {
                  attrs: {
                    vMoney: "",
                    format: _vm.int,
                    type: "number",
                    id: "minutos_firma",
                    placeholder: "(En minutos)"
                  },
                  model: {
                    value: _vm.form.minutos_firma,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "minutos_firma", $$v)
                    },
                    expression: "form.minutos_firma"
                  }
                },
                [
                  _c("span", [_vm._v("Intervalo de firma de documentos")]),
                  _vm._v(" "),
                  _vm.errores.minutos_firma
                    ? _c(
                        "span",
                        {
                          staticClass: "helper-text text-danger",
                          attrs: { slot: "helper" },
                          slot: "helper"
                        },
                        [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.errores.minutos_firma[0]))
                          ])
                        ]
                      )
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.superadmin === "S",
              expression: "superadmin === 'S'"
            }
          ],
          staticClass: "col-xs-12 col-md-4"
        },
        [
          _c(
            "div",
            { staticClass: "form-field" },
            [
              _c(
                "input-field",
                {
                  attrs: {
                    vMoney: "",
                    format: _vm.int,
                    type: "number",
                    id: "minutos_autorizacion",
                    placeholder: "(En minutos)"
                  },
                  model: {
                    value: _vm.form.minutos_autorizacion,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "minutos_autorizacion", $$v)
                    },
                    expression: "form.minutos_autorizacion"
                  }
                },
                [
                  _c("span", [
                    _vm._v("Intervalo de autorización de documentos")
                  ]),
                  _vm._v(" "),
                  _vm.errores.minutos_autorizacion
                    ? _c(
                        "span",
                        {
                          staticClass: "helper-text text-danger",
                          attrs: { slot: "helper" },
                          slot: "helper"
                        },
                        [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.errores.minutos_autorizacion[0]))
                          ])
                        ]
                      )
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.superadmin === "S",
              expression: "superadmin === 'S'"
            }
          ],
          staticClass: "col-xs-12 col-md-4"
        },
        [
          _c(
            "div",
            { staticClass: "form-field" },
            [
              _c(
                "input-field",
                {
                  attrs: {
                    vMoney: "",
                    format: _vm.int,
                    type: "number",
                    id: "minutos_email",
                    placeholder: "(En minutos)"
                  },
                  model: {
                    value: _vm.form.minutos_email,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "minutos_email", $$v)
                    },
                    expression: "form.minutos_email"
                  }
                },
                [
                  _c("span", [_vm._v("Intervalo de envío de correos")]),
                  _vm._v(" "),
                  _vm.errores.minutos_email
                    ? _c(
                        "span",
                        {
                          staticClass: "helper-text text-danger",
                          attrs: { slot: "helper" },
                          slot: "helper"
                        },
                        [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.errores.minutos_email[0]))
                          ])
                        ]
                      )
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.superadmin === "S",
              expression: "superadmin === 'S'"
            }
          ],
          staticClass: "col-xs-12 col-md-4"
        },
        [
          _c(
            "div",
            { staticClass: "form-field" },
            [
              _c(
                "input-field",
                {
                  attrs: {
                    type: "text",
                    id: "servidor_smtp",
                    placeholder: "Nombre de fichero"
                  },
                  model: {
                    value: _vm.form.path_correo,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "path_correo", $$v)
                    },
                    expression: "form.path_correo"
                  }
                },
                [
                  _c("span", [_vm._v("Plantilla de correo (HTML)")]),
                  _vm._v(" "),
                  _vm.errores.path_correo
                    ? _c(
                        "span",
                        {
                          staticClass: "helper-text text-danger",
                          attrs: { slot: "helper" },
                          slot: "helper"
                        },
                        [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.errores.path_correo[0]))
                          ])
                        ]
                      )
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.superadmin === "S",
              expression: "superadmin === 'S'"
            }
          ],
          staticClass: "col-xs-12 col-md-4"
        },
        [
          _c(
            "div",
            { staticClass: "form-field" },
            [
              _c(
                "input-field",
                {
                  attrs: {
                    type: "text",
                    id: "plantilla_factura",
                    placeholder: "Nombre de fichero"
                  },
                  model: {
                    value: _vm.form.path_factura,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "path_factura", $$v)
                    },
                    expression: "form.path_factura"
                  }
                },
                [
                  _c("span", [_vm._v("Plantilla de factura (HTML)")]),
                  _vm._v(" "),
                  _vm.errores.path_factura
                    ? _c(
                        "span",
                        {
                          staticClass: "helper-text text-danger",
                          attrs: { slot: "helper" },
                          slot: "helper"
                        },
                        [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.errores.path_factura[0]))
                          ])
                        ]
                      )
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.superadmin === "S",
              expression: "superadmin === 'S'"
            }
          ],
          staticClass: "col-xs-12 col-md-4"
        },
        [
          _c(
            "div",
            { staticClass: "form-field" },
            [
              _c(
                "input-field",
                {
                  attrs: {
                    type: "text",
                    id: "plantilla_nc",
                    placeholder: "Nombre de fichero"
                  },
                  model: {
                    value: _vm.form.path_nota_credito,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "path_nota_credito", $$v)
                    },
                    expression: "form.path_nota_credito"
                  }
                },
                [
                  _c("span", [_vm._v("Plantilla de nota de crédito (HTML)")]),
                  _vm._v(" "),
                  _vm.errores.path_nota_credito
                    ? _c(
                        "span",
                        {
                          staticClass: "helper-text text-danger",
                          attrs: { slot: "helper" },
                          slot: "helper"
                        },
                        [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.errores.path_nota_credito[0]))
                          ])
                        ]
                      )
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.superadmin === "S",
              expression: "superadmin === 'S'"
            }
          ],
          staticClass: "col-xs-12 col-md-4"
        },
        [
          _c(
            "div",
            { staticClass: "form-field" },
            [
              _c(
                "input-field",
                {
                  attrs: {
                    type: "text",
                    id: "plantilla_retencion",
                    placeholder: "Nombre de fichero"
                  },
                  model: {
                    value: _vm.form.path_retencion,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "path_retencion", $$v)
                    },
                    expression: "form.path_retencion"
                  }
                },
                [
                  _c("span", [_vm._v("Plantilla de retención (HTML)")]),
                  _vm._v(" "),
                  _vm.errores.path_retencion
                    ? _c(
                        "span",
                        {
                          staticClass: "helper-text text-danger",
                          attrs: { slot: "helper" },
                          slot: "helper"
                        },
                        [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.errores.path_retencion[0]))
                          ])
                        ]
                      )
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.superadmin === "S",
              expression: "superadmin === 'S'"
            }
          ],
          staticClass: "col-xs-12 col-md-4"
        },
        [
          _c(
            "div",
            { staticClass: "form-field" },
            [
              _c(
                "input-field",
                {
                  attrs: {
                    type: "text",
                    id: "plantilla_gr",
                    placeholder: "Nombre de fichero"
                  },
                  model: {
                    value: _vm.form.path_guia_remision,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "path_guia_remision", $$v)
                    },
                    expression: "form.path_guia_remision"
                  }
                },
                [
                  _c("span", [_vm._v("Plantilla de guía de remisión (HTML)")]),
                  _vm._v(" "),
                  _vm.errores.path_guia_remision
                    ? _c(
                        "span",
                        {
                          staticClass: "helper-text text-danger",
                          attrs: { slot: "helper" },
                          slot: "helper"
                        },
                        [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.errores.path_guia_remision[0]))
                          ])
                        ]
                      )
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.superadmin === "S",
              expression: "superadmin === 'S'"
            }
          ],
          staticClass: "col-xs-12 col-md-4"
        },
        [
          _c(
            "div",
            { staticClass: "form-field" },
            [
              _c(
                "input-field",
                {
                  attrs: {
                    type: "text",
                    id: "servidor_smtp",
                    placeholder: "##.##"
                  },
                  model: {
                    value: _vm.form.precision,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "precision", $$v)
                    },
                    expression: "form.precision"
                  }
                },
                [
                  _c("span", [_vm._v("Precisión de decimales")]),
                  _vm._v(" "),
                  _vm.errores.precision
                    ? _c(
                        "span",
                        {
                          staticClass: "helper-text text-danger",
                          attrs: { slot: "helper" },
                          slot: "helper"
                        },
                        [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.errores.precision[0]))
                          ])
                        ]
                      )
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.superadmin === "S",
              expression: "superadmin === 'S'"
            }
          ],
          staticClass: "col-xs-12 col-md-4"
        },
        [
          _c(
            "div",
            { staticClass: "form-field" },
            [
              _c(
                "input-field",
                {
                  directives: [
                    {
                      name: "mask",
                      rawName: "v-mask",
                      value: "###",
                      expression: "'###'"
                    }
                  ],
                  attrs: {
                    type: "tel",
                    id: "dias_alerta_pago",
                    placeholder: "###"
                  },
                  model: {
                    value: _vm.form.dias_alerta,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "dias_alerta", $$v)
                    },
                    expression: "form.dias_alerta"
                  }
                },
                [
                  _c("span", [_vm._v("Días de alerta de pago")]),
                  _vm._v(" "),
                  _vm.errores.dias_alerta
                    ? _c(
                        "span",
                        {
                          staticClass: "helper-text text-danger",
                          attrs: { slot: "helper" },
                          slot: "helper"
                        },
                        [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.errores.dias_alerta[0]))
                          ])
                        ]
                      )
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.superadmin === "S",
              expression: "superadmin === 'S'"
            }
          ],
          staticClass: "col-xs-12 col-md-4"
        },
        [
          _c(
            "div",
            { staticClass: "form-field" },
            [
              _c(
                "input-field",
                {
                  directives: [
                    {
                      name: "mask",
                      rawName: "v-mask",
                      value: "###",
                      expression: "'###'"
                    }
                  ],
                  attrs: {
                    type: "text",
                    id: "altura_footer",
                    placeholder: "###"
                  },
                  model: {
                    value: _vm.form.altura_footer,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "altura_footer", $$v)
                    },
                    expression: "form.altura_footer"
                  }
                },
                [
                  _c("span", [_vm._v("Altura del Footer (px)")]),
                  _vm._v(" "),
                  _vm.errores.altura_footer
                    ? _c(
                        "span",
                        {
                          staticClass: "helper-text text-danger",
                          attrs: { slot: "helper" },
                          slot: "helper"
                        },
                        [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.errores.altura_footer[0]))
                          ])
                        ]
                      )
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.superadmin === "S",
              expression: "superadmin === 'S'"
            }
          ],
          staticClass: "col-xs-12 col-md-4"
        },
        [
          _c(
            "div",
            { staticClass: "form-field" },
            [
              _c(
                "input-field",
                {
                  directives: [
                    {
                      name: "mask",
                      rawName: "v-mask",
                      value: "###",
                      expression: "'###'"
                    }
                  ],
                  attrs: {
                    type: "text",
                    id: "altura_logo",
                    placeholder: "###"
                  },
                  model: {
                    value: _vm.form.altura_logo,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "altura_logo", $$v)
                    },
                    expression: "form.altura_logo"
                  }
                },
                [
                  _c("span", [_vm._v("Altura del logo (px)")]),
                  _vm._v(" "),
                  _vm.errores.altura_logo
                    ? _c(
                        "span",
                        {
                          staticClass: "helper-text text-danger",
                          attrs: { slot: "helper" },
                          slot: "helper"
                        },
                        [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.errores.altura_logo[0]))
                          ])
                        ]
                      )
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.superadmin === "S",
              expression: "superadmin === 'S'"
            }
          ],
          staticClass: "col-xs-12 col-md-4"
        },
        [
          _c("div", { staticClass: "form-field" }, [
            _c("label", { attrs: { for: "enviar_comprobantes_anulados" } }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.enviar_comprobantes_anulados,
                    expression: "form.enviar_comprobantes_anulados"
                  }
                ],
                attrs: {
                  type: "checkbox",
                  name: "enviar_comprobantes_anulados",
                  id: "enviar_comprobantes_anulados"
                },
                domProps: {
                  checked: Array.isArray(_vm.form.enviar_comprobantes_anulados)
                    ? _vm._i(_vm.form.enviar_comprobantes_anulados, null) > -1
                    : _vm.form.enviar_comprobantes_anulados
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.form.enviar_comprobantes_anulados,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(
                            _vm.form,
                            "enviar_comprobantes_anulados",
                            $$a.concat([$$v])
                          )
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.form,
                            "enviar_comprobantes_anulados",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.form, "enviar_comprobantes_anulados", $$c)
                    }
                  }
                }
              }),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  "Enviar por correo los comprobantes electrónicos anulados"
                )
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.superadmin === "S",
              expression: "superadmin === 'S'"
            }
          ],
          staticClass: "col-xs-12 col-md-4"
        },
        [
          _c(
            "div",
            { staticClass: "form-field" },
            [
              _c(
                "input-field",
                {
                  attrs: {
                    type: "text",
                    id: "smtp_alertas_host",
                    placeholder: "Host SMTP"
                  },
                  model: {
                    value: _vm.form.smtp_alertas_host,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "smtp_alertas_host", $$v)
                    },
                    expression: "form.smtp_alertas_host"
                  }
                },
                [
                  _c("span", [_vm._v("Servidor SMTP (Alertas de saldos)")]),
                  _vm._v(" "),
                  _vm.errores.smtp_alertas_host
                    ? _c(
                        "span",
                        {
                          staticClass: "helper-text text-danger",
                          attrs: { slot: "helper" },
                          slot: "helper"
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.errores.smtp_alertas_host[0]) +
                              "\n          "
                          )
                        ]
                      )
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.superadmin === "S",
              expression: "superadmin === 'S'"
            }
          ],
          staticClass: "col-xs-12 col-md-4"
        },
        [
          _c(
            "div",
            { staticClass: "form-field" },
            [
              _c(
                "input-field",
                {
                  directives: [
                    {
                      name: "mask",
                      rawName: "v-mask",
                      value: "######",
                      expression: "'######'"
                    }
                  ],
                  attrs: {
                    type: "tel",
                    id: "smtp_alertas_port",
                    placeholder: "Puerto SMTP"
                  },
                  model: {
                    value: _vm.form.smtp_alertas_port,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "smtp_alertas_port", $$v)
                    },
                    expression: "form.smtp_alertas_port"
                  }
                },
                [
                  _c("span", [_vm._v("Puerto SMTP (Alertas de saldos)")]),
                  _vm._v(" "),
                  _vm.errores.smtp_alertas_port
                    ? _c(
                        "span",
                        {
                          staticClass: "helper-text text-danger",
                          attrs: { slot: "helper" },
                          slot: "helper"
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.errores.smtp_alertas_port[0]) +
                              "\n          "
                          )
                        ]
                      )
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.superadmin === "S",
              expression: "superadmin === 'S'"
            }
          ],
          staticClass: "col-xs-12 col-md-4"
        },
        [
          _c("p", [
            _c("label", { attrs: { for: "smtp_alertas_tls" } }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.smtp_alertas_tls,
                    expression: "form.smtp_alertas_tls"
                  }
                ],
                attrs: {
                  type: "checkbox",
                  name: "smtp_alertas_tls",
                  id: "smtp_alertas_tls"
                },
                domProps: {
                  checked: Array.isArray(_vm.form.smtp_alertas_tls)
                    ? _vm._i(_vm.form.smtp_alertas_tls, null) > -1
                    : _vm.form.smtp_alertas_tls
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.form.smtp_alertas_tls,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(
                            _vm.form,
                            "smtp_alertas_tls",
                            $$a.concat([$$v])
                          )
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.form,
                            "smtp_alertas_tls",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.form, "smtp_alertas_tls", $$c)
                    }
                  }
                }
              }),
              _c("span", [_vm._v("SSL/TLS SMTP (Alertas de saldos)")])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.superadmin === "S",
              expression: "superadmin === 'S'"
            }
          ],
          staticClass: "col-xs-12 col-md-4"
        },
        [
          _c(
            "div",
            { staticClass: "form-field" },
            [
              _c(
                "input-field",
                {
                  attrs: {
                    type: "text",
                    id: "smtp_alertas_usuario",
                    placeholder: "Usuario SMTP"
                  },
                  model: {
                    value: _vm.form.smtp_alertas_usuario,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "smtp_alertas_usuario", $$v)
                    },
                    expression: "form.smtp_alertas_usuario"
                  }
                },
                [
                  _c("span", [_vm._v("Usuario SMTP (Alertas de saldos)")]),
                  _vm._v(" "),
                  _vm.errores.smtp_alertas_usuario
                    ? _c(
                        "span",
                        {
                          staticClass: "helper-text text-danger",
                          attrs: { slot: "helper" },
                          slot: "helper"
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.errores.smtp_alertas_usuario[0]) +
                              "\n          "
                          )
                        ]
                      )
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.superadmin === "S",
              expression: "superadmin === 'S'"
            }
          ],
          staticClass: "col-xs-12 col-md-4"
        },
        [
          _c(
            "div",
            { staticClass: "form-field" },
            [
              _c(
                "input-field",
                {
                  attrs: {
                    type: "password",
                    id: "smtp_alertas_password",
                    placeholder: "Contraseña SMTP"
                  },
                  model: {
                    value: _vm.form.smtp_alertas_password,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "smtp_alertas_password", $$v)
                    },
                    expression: "form.smtp_alertas_password"
                  }
                },
                [
                  _c("span", [_vm._v("Contraseña SMTP (Alertas de saldos)")]),
                  _vm._v(" "),
                  _vm.errores.smtp_alertas_password
                    ? _c(
                        "span",
                        {
                          staticClass: "helper-text text-danger",
                          attrs: { slot: "helper" },
                          slot: "helper"
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.errores.smtp_alertas_password[0]) +
                              "\n          "
                          )
                        ]
                      )
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.superadmin === "S",
              expression: "superadmin === 'S'"
            }
          ],
          staticClass: "col-xs-12 col-md-4"
        },
        [
          _c(
            "div",
            { staticClass: "form-field" },
            [
              _c(
                "input-field",
                {
                  directives: [
                    {
                      name: "mask",
                      rawName: "v-mask",
                      value: "######",
                      expression: "'######'"
                    }
                  ],
                  attrs: {
                    type: "tel",
                    id: "smtp_alertas_dias_antelacion",
                    placeholder: "# Días"
                  },
                  model: {
                    value: _vm.form.smtp_alertas_dias_antelacion,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "smtp_alertas_dias_antelacion", $$v)
                    },
                    expression: "form.smtp_alertas_dias_antelacion"
                  }
                },
                [
                  _c("span", [_vm._v("Días de antelación")]),
                  _vm._v(" "),
                  _vm.errores.smtp_alertas_dias_antelacion
                    ? _c(
                        "span",
                        {
                          staticClass: "helper-text text-danger",
                          attrs: { slot: "helper" },
                          slot: "helper"
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.errores.smtp_alertas_dias_antelacion[0]
                              ) +
                              "\n          "
                          )
                        ]
                      )
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.superadmin === "S",
              expression: "superadmin === 'S'"
            }
          ],
          staticClass: "col-xs-12 col-md-4"
        },
        [
          _c(
            "div",
            { staticClass: "form-field" },
            [
              _c(
                "input-field",
                {
                  attrs: {
                    type: "email",
                    id: "smtp_alertas_correo_emisor",
                    placeholder: "Escriba el correo de emisión..."
                  },
                  model: {
                    value: _vm.form.smtp_alertas_correo_emisor,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "smtp_alertas_correo_emisor", $$v)
                    },
                    expression: "form.smtp_alertas_correo_emisor"
                  }
                },
                [
                  _c("span", [
                    _vm._v("Correo de emisor SMTP (Alertas de saldos)")
                  ]),
                  _vm._v(" "),
                  _vm.errores.smtp_alertas_correo_emisor
                    ? _c(
                        "span",
                        {
                          staticClass: "helper-text text-danger",
                          attrs: { slot: "helper" },
                          slot: "helper"
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.errores.smtp_alertas_correo_emisor[0]
                              ) +
                              "\n          "
                          )
                        ]
                      )
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.superadmin === "S",
              expression: "superadmin === 'S'"
            }
          ],
          staticClass: "col-xs-12 col-md-4"
        },
        [
          _c(
            "div",
            { staticClass: "form-field" },
            [
              _c(
                "input-field",
                {
                  attrs: {
                    type: "text",
                    id: "smtp_alertas_nombre_emisor",
                    placeholder: "Escriba el nombre del emisor..."
                  },
                  model: {
                    value: _vm.form.smtp_alertas_nombre_emisor,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "smtp_alertas_nombre_emisor", $$v)
                    },
                    expression: "form.smtp_alertas_nombre_emisor"
                  }
                },
                [
                  _c("span", [
                    _vm._v("Nombre de emisor SMTP (Alertas de saldos)")
                  ]),
                  _vm._v(" "),
                  _vm.errores.smtp_alertas_nombre_emisor
                    ? _c(
                        "span",
                        {
                          staticClass: "helper-text text-danger",
                          attrs: { slot: "helper" },
                          slot: "helper"
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.errores.smtp_alertas_nombre_emisor[0]
                              ) +
                              "\n          "
                          )
                        ]
                      )
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  type: "email",
                  id: "correos_notificacion_facturacion",
                  placeholder: "Escriba los correos de notificación..."
                },
                model: {
                  value: _vm.form.correos_notificacion_facturacion,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "correos_notificacion_facturacion", $$v)
                  },
                  expression: "form.correos_notificacion_facturacion"
                }
              },
              [
                _c("span", [
                  _vm._v("Correos de notificación de comprobantes no enviados")
                ]),
                _vm._v(" "),
                _vm.errores.correos_notificacion_facturacion
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.errores.correos_notificacion_facturacion[0]
                            ) +
                            "\n          "
                        )
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.superadmin == "S"
        ? _c("div", { staticClass: "col-xs-12 col-md-4" }, [
            _c("div", { staticClass: "form-field select2" }, [
              _c(
                "div",
                { staticClass: "select2-field" },
                [
                  _c("v-select", {
                    attrs: {
                      placeholder: "Seleccione un Control de documento...",
                      id: "control_documento",
                      options: _vm.opcionesControlDocumento,
                      label: "descripcion"
                    },
                    on: { input: _vm.inputControlDocumento },
                    model: {
                      value: _vm.selectedControlDocumento,
                      callback: function($$v) {
                        _vm.selectedControlDocumento = $$v
                      },
                      expression: "selectedControlDocumento"
                    }
                  }),
                  _vm._v(" "),
                  _c("label", [_vm._v("Control de documento")]),
                  _vm._v(" "),
                  _vm.errores.control_documento
                    ? _c(
                        "span",
                        {
                          staticClass: "helper-text text-danger",
                          attrs: { slot: "helper" },
                          slot: "helper"
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.errores.control_documento[0]) +
                              "\n          "
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.superadmin == "S"
        ? _c("div", { staticClass: "col-xs-12 col-md-4" }, [
            _c(
              "div",
              { staticClass: "form-field" },
              [
                _c(
                  "input-field",
                  {
                    directives: [
                      {
                        name: "mask",
                        rawName: "v-mask",
                        value: "##########",
                        expression: "'##########'"
                      }
                    ],
                    attrs: {
                      type: "text",
                      id: "cantidad_documento",
                      placeholder: "Escriba la cantidad de documento..."
                    },
                    model: {
                      value: _vm.form.cantidad_documento,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "cantidad_documento", $$v)
                      },
                      expression: "form.cantidad_documento"
                    }
                  },
                  [
                    _c("span", [_vm._v("Cantidad de documento")]),
                    _vm._v(" "),
                    _vm.errores.cantidad_documento
                      ? _c(
                          "span",
                          {
                            staticClass: "helper-text text-danger",
                            attrs: { slot: "helper" },
                            slot: "helper"
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.errores.cantidad_documento[0]) +
                                "\n          "
                            )
                          ]
                        )
                      : _vm._e()
                  ]
                )
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.superadmin == "S"
        ? _c("div", { staticClass: "col-xs-12 col-md-4" }, [
            _c(
              "div",
              { staticClass: "form-field" },
              [
                _c(
                  "textarea-field",
                  {
                    attrs: {
                      type: "email",
                      id: "correos_notificacion",
                      placeholder: "Escriba los correos de notificación..."
                    },
                    model: {
                      value: _vm.form.correos_notificacion,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "correos_notificacion", $$v)
                      },
                      expression: "form.correos_notificacion"
                    }
                  },
                  [
                    _c("span", [_vm._v("Correos de notificación")]),
                    _vm._v(" "),
                    _vm.errores.correos_notificacion
                      ? _c(
                          "span",
                          {
                            staticClass: "helper-text text-danger",
                            attrs: { slot: "helper" },
                            slot: "helper"
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.errores.correos_notificacion[0]) +
                                "\n          "
                            )
                          ]
                        )
                      : _vm._e()
                  ]
                )
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.superadmin == "S"
        ? _c("div", { staticClass: "col-xs-12 col-md-4" }, [
            _c(
              "div",
              { staticClass: "datepicker-field" },
              [
                _c("date-picker", {
                  attrs: {
                    type: "date",
                    id: "fecha_inicio_contrato",
                    placeholder: "Escriba la fecha de inicio de contrato..."
                  },
                  model: {
                    value: _vm.form.fecha_inicio_contrato,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "fecha_inicio_contrato", $$v)
                    },
                    expression: "form.fecha_inicio_contrato"
                  }
                }),
                _vm._v(" "),
                _c("label", [_vm._v("Fecha de inicio de contrato")]),
                _vm._v(" "),
                _vm.errores.fecha_inicio_contrato
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.errores.fecha_inicio_contrato[0]) +
                            "\n        "
                        )
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.superadmin == "S"
        ? _c("div", { staticClass: "col-xs-12 col-md-4" }, [
            _c("div", { staticClass: "form-field mt-2" }, [
              _c(
                "div",
                { staticClass: "datepicker-field datepicker-field--stretch" },
                [
                  _c("VueCtkDateTimePicker", {
                    attrs: {
                      id: "fecha_desde",
                      locale: "es",
                      "no-label": "",
                      "only-date": "",
                      "auto-close": "",
                      "button-now-translation": "Ahora",
                      format: "YYYY-MM-DD",
                      formatted: "YYYY-MM-DD",
                      label: "Seleccione fecha..."
                    },
                    model: {
                      value: _vm.form.fecha_caducidad_firma,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "fecha_caducidad_firma", $$v)
                      },
                      expression: "form.fecha_caducidad_firma"
                    }
                  }),
                  _vm._v(" "),
                  _c("label", [_vm._v("Fecha caducidad de firma")]),
                  _vm._v(" "),
                  _vm.errores.fecha_caducidad_firma
                    ? _c(
                        "span",
                        {
                          staticClass: "helper-text text-danger",
                          attrs: { slot: "helper" },
                          slot: "helper"
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.errores.fecha_caducidad_firma[0]) +
                              "\n          "
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.superadmin == "S"
        ? _c("div", { staticClass: "col-xs-12 col-md-4" }, [
            _c("div", { staticClass: "form-field" }, [
              _c("label", { attrs: { for: "repetir_cabecera_ride" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.repetir_cabecera_ride,
                      expression: "form.repetir_cabecera_ride"
                    }
                  ],
                  staticClass: "is-filled",
                  attrs: {
                    type: "checkbox",
                    name: "repetir_cabecera_ride",
                    id: "repetir_cabecera_ride"
                  },
                  domProps: {
                    checked: Array.isArray(_vm.form.repetir_cabecera_ride)
                      ? _vm._i(_vm.form.repetir_cabecera_ride, null) > -1
                      : _vm.form.repetir_cabecera_ride
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.form.repetir_cabecera_ride,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.form,
                              "repetir_cabecera_ride",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.form,
                              "repetir_cabecera_ride",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.form, "repetir_cabecera_ride", $$c)
                      }
                    }
                  }
                }),
                _c("span", [_vm._v("Repetir cabecera en RIDE")])
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.superadmin == "S"
        ? _c("div", { staticClass: "col-xs-12 col-md-4" }, [
            _c("div", { staticClass: "form-field" }, [
              _c("label", { attrs: { for: "datos_factura_resumida" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.datos_factura_resumida,
                      expression: "form.datos_factura_resumida"
                    }
                  ],
                  staticClass: "is-filled",
                  attrs: {
                    type: "checkbox",
                    name: "datos_factura_resumida",
                    id: "datos_factura_resumida"
                  },
                  domProps: {
                    checked: Array.isArray(_vm.form.datos_factura_resumida)
                      ? _vm._i(_vm.form.datos_factura_resumida, null) > -1
                      : _vm.form.datos_factura_resumida
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.form.datos_factura_resumida,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.form,
                              "datos_factura_resumida",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.form,
                              "datos_factura_resumida",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.form, "datos_factura_resumida", $$c)
                      }
                    }
                  }
                }),
                _c("span", [_vm._v("Datos de Factura Resumidos")])
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.superadmin == "S"
        ? _c("div", { staticClass: "col-xs-12 col-md-4" }, [
            _c("div", { staticClass: "form-field" }, [
              _c("label", { attrs: { for: "datos_persona_resumida" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.datos_persona_resumida,
                      expression: "form.datos_persona_resumida"
                    }
                  ],
                  staticClass: "is-filled",
                  attrs: {
                    type: "checkbox",
                    name: "datos_persona_resumida",
                    id: "datos_persona_resumida"
                  },
                  domProps: {
                    checked: Array.isArray(_vm.form.datos_persona_resumida)
                      ? _vm._i(_vm.form.datos_persona_resumida, null) > -1
                      : _vm.form.datos_persona_resumida
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.form.datos_persona_resumida,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.form,
                              "datos_persona_resumida",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.form,
                              "datos_persona_resumida",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.form, "datos_persona_resumida", $$c)
                      }
                    }
                  }
                }),
                _c("span", [_vm._v("Datos de Personas Resumidos")])
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.superadmin == "S"
        ? _c("div", { staticClass: "col-xs-12 col-md-4" }, [
            _c(
              "div",
              { staticClass: "form-field" },
              [
                _c(
                  "input-field",
                  {
                    directives: [
                      {
                        name: "mask",
                        rawName: "v-mask",
                        value: "##",
                        expression: "'##'"
                      }
                    ],
                    attrs: {
                      type: "text",
                      id: "dias_envio_automatico",
                      placeholder: "Escriba la cantidad de documento..."
                    },
                    model: {
                      value: _vm.form.dias_envio_automatico,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "dias_envio_automatico", $$v)
                      },
                      expression: "form.dias_envio_automatico"
                    }
                  },
                  [
                    _c("span", [
                      _vm._v("Días de Envío Automático de Comp. Electrónicos")
                    ]),
                    _vm._v(" "),
                    _vm.errores.dias_envio_automatico
                      ? _c(
                          "span",
                          {
                            staticClass: "helper-text text-danger",
                            attrs: { slot: "helper" },
                            slot: "helper"
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.errores.dias_envio_automatico[0]) +
                                "\n          "
                            )
                          ]
                        )
                      : _vm._e()
                  ]
                )
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.superadmin === "S",
              expression: "superadmin === 'S'"
            }
          ],
          staticClass: "col-xs-12 col-md-4"
        },
        [
          _c("div", { staticClass: "form-field" }, [
            _c("p", [
              _c("label", { attrs: { for: "envio_automatico_fac" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.envio_automatico_fac,
                      expression: "form.envio_automatico_fac"
                    }
                  ],
                  attrs: { type: "checkbox", id: "envio_automatico_fac" },
                  domProps: {
                    checked: Array.isArray(_vm.form.envio_automatico_fac)
                      ? _vm._i(_vm.form.envio_automatico_fac, null) > -1
                      : _vm.form.envio_automatico_fac
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.form.envio_automatico_fac,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.form,
                              "envio_automatico_fac",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.form,
                              "envio_automatico_fac",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.form, "envio_automatico_fac", $$c)
                      }
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", [
                  _vm._v("Envío automático de Facturas Electrónicas")
                ])
              ])
            ]),
            _vm._v(" "),
            _c("p", [
              _c("label", { attrs: { for: "envio_automatico_nc" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.envio_automatico_nc,
                      expression: "form.envio_automatico_nc"
                    }
                  ],
                  attrs: { type: "checkbox", id: "envio_automatico_nc" },
                  domProps: {
                    checked: Array.isArray(_vm.form.envio_automatico_nc)
                      ? _vm._i(_vm.form.envio_automatico_nc, null) > -1
                      : _vm.form.envio_automatico_nc
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.form.envio_automatico_nc,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.form,
                              "envio_automatico_nc",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.form,
                              "envio_automatico_nc",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.form, "envio_automatico_nc", $$c)
                      }
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", [
                  _vm._v("Envío automático de Notas de Crédito Electrónicas")
                ])
              ])
            ]),
            _vm._v(" "),
            _c("p", [
              _c("label", { attrs: { for: "envio_automatico_gr" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.envio_automatico_gr,
                      expression: "form.envio_automatico_gr"
                    }
                  ],
                  attrs: { type: "checkbox", id: "envio_automatico_gr" },
                  domProps: {
                    checked: Array.isArray(_vm.form.envio_automatico_gr)
                      ? _vm._i(_vm.form.envio_automatico_gr, null) > -1
                      : _vm.form.envio_automatico_gr
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.form.envio_automatico_gr,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.form,
                              "envio_automatico_gr",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.form,
                              "envio_automatico_gr",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.form, "envio_automatico_gr", $$c)
                      }
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", [
                  _vm._v("Envío automático de Guías de Remisión Electrónicas")
                ])
              ])
            ]),
            _vm._v(" "),
            _c("p", [
              _c("label", { attrs: { for: "envio_automatico_ret" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.envio_automatico_ret,
                      expression: "form.envio_automatico_ret"
                    }
                  ],
                  attrs: { type: "checkbox", id: "envio_automatico_ret" },
                  domProps: {
                    checked: Array.isArray(_vm.form.envio_automatico_ret)
                      ? _vm._i(_vm.form.envio_automatico_ret, null) > -1
                      : _vm.form.envio_automatico_ret
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.form.envio_automatico_ret,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.form,
                              "envio_automatico_ret",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.form,
                              "envio_automatico_ret",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.form, "envio_automatico_ret", $$c)
                      }
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", [
                  _vm._v("Envío automático de Retenciones Electrónicas")
                ])
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c("div", { staticClass: "form-field" }, [
          _vm.superadmin == "S"
            ? _c("p", [
                _c("label", { attrs: { for: "iva_incluido_exp" } }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.iva_incluido_exp,
                        expression: "form.iva_incluido_exp"
                      }
                    ],
                    attrs: { type: "checkbox", id: "iva_incluido_exp" },
                    domProps: {
                      checked: Array.isArray(_vm.form.iva_incluido_exp)
                        ? _vm._i(_vm.form.iva_incluido_exp, null) > -1
                        : _vm.form.iva_incluido_exp
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.form.iva_incluido_exp,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.form,
                                "iva_incluido_exp",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.form,
                                "iva_incluido_exp",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.form, "iva_incluido_exp", $$c)
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("IVA incluido en exportaciones")])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.superadmin == "S"
            ? _c("p", [
                _c("label", { attrs: { for: "modulo_proyecto" } }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.modulo_proyecto,
                        expression: "form.modulo_proyecto"
                      }
                    ],
                    attrs: { type: "checkbox", id: "modulo_proyecto" },
                    domProps: {
                      checked: Array.isArray(_vm.form.modulo_proyecto)
                        ? _vm._i(_vm.form.modulo_proyecto, null) > -1
                        : _vm.form.modulo_proyecto
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.form.modulo_proyecto,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.form,
                                "modulo_proyecto",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.form,
                                "modulo_proyecto",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.form, "modulo_proyecto", $$c)
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Habilitar modulo de Proyectos")])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.superadmin === "S"
            ? _c("p", [
                _c(
                  "label",
                  { attrs: { for: "no_anular_consumidor_final_aut" } },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.no_anular_consumidor_final_aut,
                          expression: "form.no_anular_consumidor_final_aut"
                        }
                      ],
                      attrs: {
                        type: "checkbox",
                        id: "no_anular_consumidor_final_aut"
                      },
                      domProps: {
                        checked: Array.isArray(
                          _vm.form.no_anular_consumidor_final_aut
                        )
                          ? _vm._i(
                              _vm.form.no_anular_consumidor_final_aut,
                              null
                            ) > -1
                          : _vm.form.no_anular_consumidor_final_aut
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.form.no_anular_consumidor_final_aut,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.form,
                                  "no_anular_consumidor_final_aut",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.form,
                                  "no_anular_consumidor_final_aut",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(
                              _vm.form,
                              "no_anular_consumidor_final_aut",
                              $$c
                            )
                          }
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v("No anular consumidor final estado autorizado")
                    ])
                  ]
                )
              ])
            : _vm._e()
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal-buttons" }, [
      _c(
        "button",
        {
          staticClass: "btn-danger btn--text",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              return _vm.$emit("cerrar")
            }
          }
        },
        [
          _c("i", { staticClass: "fa fa-sign-out" }),
          _vm._v(" "),
          _c("span", [_vm._v("Cerrar")])
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn-success",
          attrs: { type: "button" },
          on: { click: _vm.guardarCambios }
        },
        [
          _c("i", { staticClass: "fa fa-save" }),
          _vm._v(" "),
          _c("span", [_vm._v("Guardar")])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__header" }, [
      _c("h3", [_vm._v("Preferencias")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-839d428a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-839d428a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/mantenimiento/parametrizacion/ParametrosPreferencias.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-839d428a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/mantenimiento/parametrizacion/ParametrosPreferencias.vue
// module chunks = 0